import { Flex } from "@instructure/ui";
import { useTranslation } from "react-i18next";
import ProgressStepper from "../../ProgressStepper";
import { getCourseReviewSteps } from "../utils";
import CourseReviewReflections from "./CourseReviewReflections";
import FacultyReflections from "./FacultyReflections";

const CourseReflections = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "1.5rem",
        height: "100%",
      }}
    >
      <ProgressStepper steps={getCourseReviewSteps(t)} currentStep={2} />
      <div
        style={{
          flex: 1,
          margin: "-0.75rem",
          padding: "0.75rem",
          overflowY: "hidden",
        }}
      >
        <Flex gap="medium" height="100%">
          <Flex.Item shouldGrow shouldShrink height="100%">
            <FacultyReflections />
          </Flex.Item>
          <Flex.Item height="100%">
            <div style={{ height: "100%", borderRight: "1px solid #ccc" }} />
          </Flex.Item>
          <Flex.Item size="50%" height="100%">
            <CourseReviewReflections />
          </Flex.Item>
        </Flex>
      </div>
    </div>
  );
};

export default CourseReflections;
